const easeInOutQuad = (time, start, change, duration) => {
  time /= duration / 2;
  if (time < 1) return (change / 2) * (time * time) + start;
  time -= 1;
  return (-change / 2) * (time * (time - 2) - 1) + start;
};

const scrollTo = (element, to, duration, afterScroll) => {
  const start = element.scrollLeft;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;

  const animateScroll = () => {
    currentTime += increment;
    element.scrollLeft = easeInOutQuad(currentTime, start, change, duration);
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    } else if (afterScroll) {
      afterScroll();
    }
  };
  animateScroll();
};

export default scrollTo;
